var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',_vm._b({attrs:{"label":_vm.label,"label-for":_vm.name}},'b-form-group',_vm.$attrs,false),[_c('validation-provider',{attrs:{"vid":_vm.name,"name":_vm.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(validationContext){return [_vm._t("default",null,null,{
				name: _vm.name,
				label: _vm.label,
				validationContext,
				state: _vm.getValidationState(validationContext),
				invalid: validationContext.invalid,
			}),_vm._v(" "),_vm._l((validationContext.errors),function(error){return _c('b-form-invalid-feedback',{key:error},[_vm._v("\n\t\t\t"+_vm._s(error)+"\n\t\t")])})]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }